module.exports = __webpack_public_path__ + "static/media/cart.ffbc30f4.svg";